module.exports = __webpack_public_path__ + "static/media/CoreUI-Icons-Linear-Free.0087dce4.woff";